import { setSessionName } from "@/apis/chat"
import { chatSessionIdQueryOption, RecentChatQueryOption } from "@/apis/query/chat"
import { useAdvancedInfiniteQuery } from "@/hooks/useAdvancedInfiniteQuery"
import { useToast } from "@/provider/ToastProvider"
import { DarkButton, LightButton } from "@/ui/Button"
import { inputStyle } from "@/ui/Forms/ResponsiveInput"
import { cn, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalProps } from "@heroui/react"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { produce } from "immer"
import { useTranslations } from "next-intl"
import { useEffect } from "react"
import { useForm } from "react-hook-form"

export default ({ isOpen, sessionId, defaultName, onOpenChange, onClose, ...props }: Omit<ModalProps, 'children'> & { sessionId: number, defaultName: string }) => {
  const t = useTranslations()
  const methods = useForm<{ session_name: string }>({
    defaultValues: {
      session_name: defaultName
    }
  })

  const { showToast } = useToast()

  const { mutate, isPending } = useMutation({ mutationFn: setSessionName })

  useEffect(() => {
    methods.reset({ session_name: defaultName })
  }, [defaultName])


  const { update } = useAdvancedInfiniteQuery(RecentChatQueryOption)
  const queryClient = useQueryClient()

  const onSubmit = (data) => {

    mutate({ session_id: sessionId, ...data }, {
      onSuccess(res) {
        
        if (res.status === 200) {
          update(item => item.id === sessionId, oldData => {
            const newName = data.session_name === "" ? oldData.chat_robot.robot_info.robot_name : data.session_name
            return {
              ...oldData,
              session_name: newName
            }
          })

          queryClient.setQueryData(chatSessionIdQueryOption(sessionId).queryKey, (oldData) => {
            if (!oldData?.data) return null
            return produce(oldData, draft => {
              const newName = data.session_name === "" ? draft.data.chat_robot.robot_info.robot_name : data.session_name
              draft.data.session_name = newName
            })
          })

          onClose && onClose()
          showToast({ type: 'success', message: res.message })

        } else {
          showToast({ type: 'error', message: res.message })
        }
      }
    })
  }


  return <>
    <Modal size="sm" isOpen={isOpen} onOpenChange={onOpenChange}>
      <ModalContent className="max-w-[360px] px-2 pb-4">
        {(onClose) => (
          <>
            <ModalHeader className="flex pt-6 text-center justify-center">
              {t("chat.setNickname")}
            </ModalHeader>
            <ModalBody>
              <form>
                <input
                  {...methods.register('session_name')}

                  className={cn(inputStyle,
                    'border-1 border-theme-primary/40 focus:border-theme-primary bg-theme-primary/5 rounded-[8px]')} />

              </form>

            </ModalBody>
            <ModalFooter className="mt-2">
              <LightButton className="w-[140px]" onPress={onClose}>{t('common.cancel')}</LightButton>
              <DarkButton className="w-[140px]" isLoading={isPending} isDisabled={!methods.formState.isDirty} onPress={methods.handleSubmit(onSubmit)}>{t('common.confirm')}</DarkButton>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  </>
}